<script>
import appConfig from '@src/app.config'
import { Auth, Hub } from 'aws-amplify'
import axios from 'axios'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
  name: '360MDR',
  data() {
    return {
      // signedIn: false
    }
  },
  // beforeCreate() {
  //   Hub.listen('auth', data => {
  //     const { payload } = data
  //     if (payload.event === 'signIn') {
  //       Auth.currentSession()
  //         .then((session) => { 
  //           axios.defaults.headers.common['Authorization'] = session.idToken.jwtToken
  //           this.$router.push('/dashboard')
  //         })
  //         .catch(() => { 

  //         })
  //     }
  //     if (payload.event === 'signOut') {
  //       axios.defaults.headers.common['Authorization'] = ''
  //       this.$router.push('/')
  //     }
  //   })
  // },
  // beforeCreate() {
  //   Hub.listen('auth', data => {
  //     const { payload } = data
  //     if (payload.event === 'signIn') {
  //       Auth.currentSession()
  //         .then((session) => { 
  //           this.$router.push('/dashboard')
  //         })
  //         .catch(() => { 

  //         })
  //     }
  //     if (payload.event === 'signOut') {
  //       this.$router.push('/')
  //     }
  //   })

  //   axios.interceptors.request.use(function (config) {
  //   return new Promise((resolve, reject) => {
  //     Auth.currentSession()
  //       .then((session) => {
  //         let idTokenExpire = session.getIdToken().getExpiration()
  //         let refreshToken = session.getRefreshToken()
  //         let currentTimeSeconds = Math.round(+new Date() / 1000)
  //         if (idTokenExpire < currentTimeSeconds) {
  //           Auth.currentAuthenticatedUser()
  //             .then((res) => {
  //               res.refreshSession(refreshToken, (err, data) => {
  //                 if (err) {
  //                   Auth.signOut()
  //                 } else {
  //                   config.headers.Authorization = data.getIdToken().getJwtToken()
  //                   resolve(config)
  //                 }
  //               })
  //             })
  //         } else {
  //           config.headers.Authorization = session.getIdToken().getJwtToken()
  //           resolve(config)          
  //         }
  //       })
  //     })
  //   })    
  // }
  beforeCreate () {
    console.log('beforeCreate')

    Hub.listen('auth', data => {
      console.log('beforeCreate auth event')

      const { payload } = data
      if (payload.event === 'signIn') {
        Auth.currentSession()
          .then((session) => {
            this.$router.push('/dashboard')
          })
          .catch(() => {

          })
      }
      if (payload.event === 'signOut') {
        this.$router.push('/')
      }
    })

    axios.interceptors.request.use(function (config) {
      return new Promise((resolve, reject) => {
        Auth.currentSession()
          .then((session) => {
            let idTokenExpire = session.getIdToken().getExpiration()
            let refreshToken = session.getRefreshToken()
            let currentTimeSeconds = Math.round(+new Date() / 1000)
            if (idTokenExpire < currentTimeSeconds) {
              Auth.currentAuthenticatedUser()
                .then((res) => {
                  res.refreshSession(refreshToken, (err, data) => {
                    if (err) {
                      Auth.signOut()
                    } else {
                      config.headers.Authorization = data.getIdToken().getJwtToken()
                      resolve(config)
                    }
                  })
                })
            } else {
              config.headers.Authorization = session.getIdToken().getJwtToken()
              resolve(config)
            }
          })
      })
    })
  }
}
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath" />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Design variables and utilities from src/design.
@import '@design';
:root {
  /* Colors */
  --amplify-background-color: white;
  --amplify-primary-color:#02A2FF;
  --amplify-primary-tint: #007ECC;
  --amplify-primary-shade:#0067A7;
  --amplify-secondary-tint:#ED2511;
  }
</style>
